/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect, useRef } from "react";
import clsx from "clsx";
import { SubmitBtnContext } from "../../App";
import { AccountContext } from "./AccountCard";
import { CompanyAccountContext } from "../../containers/CompanyProfile";
import {
  Grid,
  Paper,
  ButtonGroup,
  Typography,
  Button,
  IconButton,
  TextField,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
  Checkbox
} from "@material-ui/core";
import { Formik } from "formik";
import useStyles from "../../styles/companyProfileFormstyle";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import { useTranslation } from "../../langs/useTranslation";
import * as localforage from "localforage";
import { useParams } from "react-router-dom";
import { updateAccountAPI } from "../../apis/updateAccountAPI";
import StyledSubmitBtn from "../../components/commons/StyledSubmitBtn";
import "../../../node_modules/noty/lib/noty.css";
import "../../../node_modules/noty/lib/themes/relax.css";
import defaultImage from "../../assets/images/default_image.svg";
import "../../css/avatarEditor.css";
import { roleSelectorDeterminator } from "../../helpers/roleSelectorDeterminator";
import { updateAccountCardFormValueSchema } from "../../config/formSchema";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { toast } from "@/helpers/toast"
import CompanyTreeModal from "../CompanyTree/Modal";
import HasPermission from "../../components/commons/HasPermission";

const AccountCardForm = props => {
  const classes = useStyles();
  const { company_id } = useParams();

  const { dispatch } = useContext(SubmitBtnContext);
  const { setAccountUpdate } = useContext(CompanyAccountContext);
  const { handleCancelEditAccount } = useContext(AccountContext);
  const { t } = useTranslation("accountCenter");
  const [activeStatus, setActiveStatus] = useState(props.activeStatus || "");
  const [name, setName] = useState(props.name || "");
  const [phone, setPhone] = useState(props.phone || "");
  const [email, setEmail] = useState(props.email || "");
  const [role, setRole] = useState(props.role || "");
  const [roleId, setRoleId] = useState(props.roleId || "");
  const [password, setPassword] = useState(props.password || "");
  const [initAvatar, setInitAvatar] = useState(
    props.avatarLink || defaultImage
  );
  const [isFormEditable, setIsFormEditable] = useState(true);
  const [isFileSizeError, setIsFileSizeError] = useState(false);
  const [isFileExtensionError, setIsFileExtensionError] = useState(false);
  const [accountID, setAccountID] = useState(props.id || "");
  const [roleArr, setRoleArr] = useState([]);
  const [userHasPermissionToAdmin, setUserHasPermissionToAdmin] =
    useState(false);
  const [isSelf, setIsSelf] = useState(false);
  const roleNeedPermission = "Administrator";
  const [isPasswordChangePermission, setPasswordChangePermission] =
    useState(false);
  const [passwordValues, setPasswordValues] = useState({
    password: password,
    showPassword: false
  });
  const [companyTreeModalOpen, setCompanyTreeModalOpen] = useState(false);
  const [invisibleCompanies, setInvisibleCompanies] = useState(props.invisible_companies || []);

  const handleClickShowPassword = () => {
    setPasswordValues({
      ...passwordValues,
      showPassword: !passwordValues.showPassword
    });
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  const checkPasswordChangePermission = async () => {
    // get the user role name
    // const user = await localforage.getItem("user");
    // const userRole = user.roles[0].name;
    // if (userRole) {
    //   const isPermission = !(userRole === roleNeedPermission);
    //   setPasswordChangePermission(isPermission);
    // }
    // if (user.id === accountID) {
    //   const isPermission = !(user.id === accountID);
    //   setPasswordChangePermission(isPermission);
    // }
  };

  const getRoleOptions = async () => {
    const userPermissions = await localforage.getItem("userPermissions");
    const user = await localforage.getItem("user");
    const roles = await roleSelectorDeterminator(company_id);
    setRoleArr(roles);
    setUserHasPermissionToAdmin(userPermissions.includes(roleNeedPermission));
    setIsSelf(user.id === accountID);
  };

  const handleShowCompanyTreeModal = () => {
    setCompanyTreeModalOpen(true);
  };

  const handleCompanyConfirm = (checkedCompanyId, excludeCompanyId) => {
    setInvisibleCompanies(excludeCompanyId);
  };

  const inputCursorStyle = !isFormEditable ? {} : { cursor: "pointer" };

  const initialValues = {
    name: name,
    phone: phone,
    email: email,
    role: role,
    roleId: roleId,
    password: password,
    active: activeStatus,
    otp_required: props.otp_required
  };

  useEffect(() => {
    getRoleOptions();
    checkPasswordChangePermission();
  }, []);

  return (
    <Grid
      item
      xl={3}
      lg={4}
      md={6}
      sm={12}
      xs={12}
      className={classes.accountCardWrap}
    >
      <Paper elevation={0} className={classes.paper}>
        <Formik
          initialValues={initialValues}
          validationSchema={updateAccountCardFormValueSchema}
          onSubmit={async (values, { setSubmitting }) => {
            if (isFileExtensionError === false && isFileSizeError === false) {
              try {
                setSubmitting(true);
                dispatch({ type: "showLoading" });
                await updateAccountAPI(
                  accountID,
                  company_id,
                  invisibleCompanies,
                  values,
                  activeStatus,
                  initAvatar,
                  defaultImage
                );
                handleCancelEditAccount();
                setAccountUpdate(true);
                toast.success(
                  t("companyProfileForm.successfullyUpdateCompany")
                );
              } finally {
                dispatch({ type: "stopLoading" });
              }
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
          }) => (
            <form
              onSubmit={handleSubmit}
              className={`${classes.mainContent} ${classes.mainContent2}`}
            >
              <div className={classes.avatarUploaderWrap}>
                <div className="avatar-editor">
                  <input
                    type="file"
                    onChange={event => {
                      setIsFileSizeError(false);
                      if (event.target.files && event.target.files[0]) {
                        const src = URL.createObjectURL(event.target.files[0]); // set src to blob url
                        const fileName = event.target.files[0].name;
                        const fileSize =
                          event.target.files[0].size / 1024 / 1024;
                        if (fileSize > 0.5) {
                          setIsFileSizeError(true);
                          return;
                        } else {
                          setIsFileSizeError(false);
                        }
                        setFieldValue("file", event.currentTarget.files);
                        setInitAvatar(src);
                      }
                    }}
                    disabled={!isFormEditable}
                    style={inputCursorStyle}
                  />
                  <div className="avatar-image">
                    <img src={initAvatar} alt="avatar" />
                  </div>
                </div>
                <div style={{ marginLeft: 12 }}>
                  <Typography variant="caption" color="secondary">
                    {t("companyProfileForm.imageSize")}
                  </Typography>
                  <Typography variant="caption" color="secondary">
                    {t("companyProfileForm.imageFormat")}
                  </Typography>
                  {isFileSizeError ? (
                    <Typography variant="caption" color="error">
                      Please upload file within 500 KB.
                    </Typography>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <TextField
                className={classes.nameTexField}
                variant="standard"
                placeholder="name *"
                name="name"
                disabled={isSubmitting}
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={errors.name && touched.name && errors.name}
                error={!!(errors.name && touched.name && errors.name)}
              />
              <TextField
                placeholder="Phone *"
                name="phone"
                value={values.phone}
                onChange={handleChange}
                disabled={isSubmitting}
                onBlur={handleBlur}
                helperText={errors.phone && touched.phone && errors.phone}
                error={!!(errors.phone && touched.phone && errors.phone)}
              />
              <TextField
                placeholder="Email *"
                name="email"
                disabled={isSubmitting}
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={errors.email && touched.email && errors.email}
                error={!!(errors.email && touched.email && errors.email)}
              />
              <TextField
                select
                SelectProps={{
                  native: true
                }}
                name="roleId"
                value={values.roleId}
                onChange={handleChange}
                className={clsx({
                  [classes.roleSelection]: !values.role,
                  [classes.roleSelected]: values.role
                })}
                onBlur={handleBlur}
                disabled={
                  isSubmitting ||
                  isSelf ||
                  (!userHasPermissionToAdmin &&
                    values.role === roleNeedPermission)
                }
                helperText={errors.role && touched.role && errors.role}
                error={!!(errors.role && touched.role && errors.role)}
              >
                <option value={null}>Select a role *</option>
                {values.role === roleNeedPermission ? (
                  <option value={values.roleId}>{values.role}</option>
                ) : (
                  ""
                )}
                {roleArr.map(role => {
                  return (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  );
                })}
              </TextField>
              {/* rick - comment out, in case Elio want it back..... */}
              <HasPermission permission="edit_account_password">
                {hasPermission => (
                  <div className={classes.passwordWrap}>
                    <TextField
                      placeholder="Change Password"
                      name="password"
                      // hidden={isSubmitting || isPasswordChangePermission}
                      disabled={
                        !hasPermission ||
                        isSubmitting ||
                        isPasswordChangePermission
                      }
                      type={passwordValues.showPassword ? "text" : "password"}
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={
                        errors.password && touched.password && errors.password
                      }
                      error={
                        !!(
                          errors.password &&
                          touched.password &&
                          errors.password
                        )
                      }
                    />
                    {hasPermission && (
                      <IconButton
                        hidden={isSubmitting}
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {passwordValues.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    )}
                  </div>
                )}
              </HasPermission>
              <HasPermission permission="edit_account_company_mapping">
                <TextField
                  className={classes.nameTexField}
                  variant="standard"
                  readOnly
                  value={t({ defaultMessage: "公司数据权限配置" })}
                  onClick={handleShowCompanyTreeModal}
                />
              </HasPermission>
              <FormControl
                className={`${classes.activeStatus} ${classes.activeStatusEditable}`}
              >
                <FormLabel className={classes.formLabel}>{t( "accountProfile.active")}</FormLabel>
                  <FormControlLabel
                    name="active"
                    value={values.active}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    control={
                      <Checkbox
                        color="primary"
                        onClick={() => {
                          setActiveStatus(!activeStatus);
                        }}
                        checked={!!activeStatus}
                        disabled={isSubmitting}
                      />
                    }
                  />
                <FormLabel className={classes.formLabel}>{t("accountProfile.2FA")}</FormLabel>
                <FormControlLabel
                  name="otp_required"
                  onChange={handleChange}
                  disabled={isSubmitting}
                  control={
                    <Checkbox checked={values.otp_required} color="primary" />
                  }
                  value={values.otp_required}
                />

                <FormHelperText
                  hidden={!(errors.active && touched.active && errors.active)}
                  error={!!(errors.active && touched.active && errors.active)}
                >
                  {errors.active && touched.active && errors.active}
                </FormHelperText>
              </FormControl>
              <div className={classes.buttonGroup}>
                <StyledSubmitBtn
                  btnColor="primary"
                  variant="text"
                  startIcon={<SendOutlinedIcon color="primary" />}
                  disabled={isSubmitting}
                  btnText={t("companyProfileForm.confirmBtn")}
                />
                <Button
                  type="button"
                  // color="secondary"
                  onClick={props.handleCancelCreateAccount}
                  disabled={isSubmitting}
                >
                  {t("companyProfileForm.cancelBtn")}
                </Button>
              </div>
            </form>
          )}
        </Formik>
        <CompanyTreeModal
          open={companyTreeModalOpen}
          companyId={company_id}
          useParamId
          excludeKeys={
            invisibleCompanies.length
              ? invisibleCompanies
              : props.invisible_companies
          }
          onClose={() => setCompanyTreeModalOpen(false)}
          onConfirm={handleCompanyConfirm}
        />
      </Paper>
    </Grid>
  );
};

export default AccountCardForm;
